module.exports = __webpack_public_path__ + "img/ba7cc3d.jpg";